const ANALITICS = {
  newAnalitics: "Nueva Estadística",
  editAnalitics: "Editar Estadística",
  listAnalitics: "Lista de estadisticas",
  newAnalitic: "Nuevo Tablero de estadística",
  alert: "Recuerda no utilizar <strong>carácteres especiales</strong>.",
  placeholderName: "Nombre",
  placeHolderUri: "Ingrese la url del tablero",
  save: "Guardar",
  clean: "Limpiar",

  name: "Estadística",
  url: "url",
  company: "Compañía",
  status: "Estado",
  actions: "Acciones",
  selectCompany: "Seleccione una compañía",

  notifyName: "Ingrese un nombre para la estadística",
  notifyNameInvalid: "Ingrese un nombre válido.",
  successStatistics: "Estadística creado con éxito!",
  updateSuccessStatistic: "Actualización éxitosa",
  erroStatistics: "Ocurrio un error, al crear la estadísica",

  emptyStatistic: "No hay estadísticas registradas.",
  deleteStatistic: "Eliminar Estadistica:",
  alertMessage: "Ésta opción no se puede deshacer, está seguro?",

  accept: "Aceptar",
  cancel: "Cancelar",
  update: "Actualizar",

  deleteStatistics: "Eliminar estadísticas",
  NotAutorization: "No posee permisos para realizar esta acción.",
  erroToDelete: "Ocurrio un error, al eliminar el grupo",
  disabledAction: "Acción no disponible de momento",

  tableStatistic: "Tablero de data estudio",
  msgErrorUrlStatistic: "La url no pertenece a un tablero de data estudio embebido válido."
};

export default { ANALITICS };
